import React from 'react';
import PropTypes from 'prop-types';
import CustomModal  from './CustomModal';
import { TextButton } from '../buttons/TextButton';

// ************************************************************************************
// This is a simple React modal component that contains some content and text buttons.
// For future reference: call this ActionReminderModal
// ************************************************************************************
export class SimpleModal extends React.Component {
  
    constructor () {
      super();
      this.state = {
        showModal: false
      };
    }
    
    handleOpenModal = () => {
      /* Set Local state */
      this.setState({ showModal: true });

       /* call parent open handler to set on showModal on parent state */
       this.props.openHandler()
    }
    
    /* closes modal but fires parent handler to take some action */
    handleCloseModal =  () => {
      /* Set Local state */
      this.setState({ showModal: false });

      /* call parent open handler to set on showModal on parent state and pass along transient data if needed. */
      this.props.closeHandler()
    }

    /* closes modal */
    handleCancelModal = () => {

      /* Set Local state */
      this.setState({ showModal: false });

      /* call parent open handler to set on showModal on parent state and pass along transient data if needed. */
      this.props.cancelHandler()
    }
    
    render () {

      let modalText  = this.props.modalText  || "Are you sure would like to take this action?";
      let cancelText = this.props.cancelText || "Cancel";
      let affirmText = this.props.affirmText || "Yes";
      let linkColor  = this.props.linkColor  || "blue";

      if (this.state.showModal === true || this.props.showModal === true) {
        return (
          <div>
            <div className="simple-modal">
                <div className="simple-modal-content">
                  {/* <span className="simple-modal-close" onClick={this.handleCloseModal}>&times;</span> */}
                  <div className="simple-modal-text">
                    <p>{modalText}</p>
                  </div>
                  <div className="simple-modal-button-container">
                    <TextButton text={cancelText} color={linkColor}
                               onClickHandler={this.handleCancelModal} />
                    <TextButton text={affirmText} color={linkColor}
                               onClickHandler={this.handleCloseModal} />
                  </div>
                </div>
            </div>
           
          </div>
       );
      } else {
        return null;
      }
    }
}

SimpleModal.propTypes = {
  showModal:      PropTypes.bool.isRequired,     /* flag to indicate when to show modal */
  openHandler:    PropTypes.func,                /* Called when you explictly want to open modal vs declaritively */
  closeHandler:   PropTypes.func.isRequired,     /* Called when user clicks the affirm text link on modal */
  cancelHandler:  PropTypes.func.isRequired,     /* Called when user clicks the cancel text link on modal */
  modalText:      PropTypes.string,              /* This is the main text */
  cancelText:     PropTypes.string,              /* This is the cancel text */
  affirmText:     PropTypes.string,              /* This is the affirm text */
  linkColor:      PropTypes.string,
  altstyle:       PropTypes.string               /* HERE if need to use alter style, that ones here */
};


// WEBPACK FOOTER //
// ./src/components/modals/SimpleModal.js